import { createToastInterface, TYPE } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const install = (Vue, { context }) => {
  if (install.installed) return
  install.installed = true

  const vuetify = context.vuetify

  const opts = {
    closeOnClick: false,
    timeout: 3000,
    position: 'top-right',
    toastClassName: 'e-toast',
    bodyClassName: 'e-toast__body',
    transition: 'Vue-Toastification__fade',
    hideProgressBar: true,
    icon: 'icon-info',
    closeButtonClassName: 'icon-close-sign',
    draggable: false,
    toastDefaults: {
      [TYPE.SUCCESS]: {
        icon: 'icon-success',
      },
      [TYPE.ERROR]: {
        icon: 'icon-danger',
      },
      [TYPE.INFO]: {
        icon: 'icon-info',
      },
      [TYPE.DEFAULT]: {
        icon: 'icon-info',
      },
      [TYPE.WARNING]: {
        icon: 'icon-exclamation',
      },
    },
    // toastClassName: [
    //   // vuetify.framework.theme.isDark ? 'theme--dark' : 'theme--light',
    //   'e-toast',
    //   // opts.small ? 'e-size--small' : '',
    // ],
    // position: vuetify.framework.breakpoint.mobile ? 'bottom-center' : 'top-right',
  }

  function getMergedOptions(options = {}) {
    return {
      position: vuetify.framework.breakpoint.mobile ? 'bottom-center' : 'top-right',
      toastClassName: [
        vuetify.framework.theme.isDark ? 'theme--dark' : 'theme--light',
        'e-toast',
        options.small ? 'e-size--small' : '',
      ],
      ...options,
    }
  }
  const toastInstance = createToastInterface(opts, Vue)
  const toast = (content, options) => toastInstance(content, getMergedOptions(options))
  toast.clear = toastInstance.clear
  toast.updateDefaults = toastInstance.updateDefaults
  toast.dismiss = toastInstance.dismiss
  toast.update = toastInstance.update
  toast.success = (content, options) => toastInstance.success(content, getMergedOptions(options))
  toast.info = (content, options) => toastInstance.info(content, getMergedOptions(options))
  toast.error = (content, options) => toastInstance.error(content, getMergedOptions(options))
  toast.warning = (content, options) => toastInstance.warning(content, getMergedOptions(options))
  Vue.$eToast = toast
  Vue.prototype.$eToast = toast
}

const ToastPlugin = {
  install,
}

export default ToastPlugin
